export const Constants = {
  COMPONENT_OPTIONS_KEY: "nuxtI18n",
  STRATEGIES: {"PREFIX":"prefix","PREFIX_EXCEPT_DEFAULT":"prefix_except_default","PREFIX_AND_DEFAULT":"prefix_and_default","NO_PREFIX":"no_prefix"},
  REDIRECT_ON_OPTIONS: {"ALL":"all","ROOT":"root","NO_PREFIX":"no prefix"},
}
export const nuxtOptions = {
  isUniversalMode: true,
  trailingSlash: false,
}
export const options = {
  vueI18n: {},
  vueI18nLoader: false,
  locales: [{"name":"Español","code":"es","iso":"es","file":"es.js"},{"name":"Español - España","code":"es-es","iso":"es-ES","file":"es-es.js"},{"name":"Español - Colombia","code":"es-co","iso":"es-CO","file":"es-co.js"},{"name":"Español - Mexico","code":"es-mx","iso":"es-MX","file":"es-mx.js"},{"name":"English","code":"en","iso":"en","file":"en.js"},{"name":"Português","code":"pt-br","iso":"pt-br","file":"pt-br.js"}],
  defaultLocale: "en",
  defaultDirection: "ltr",
  routesNameSeparator: "___",
  defaultLocaleRouteNameSuffix: "default",
  sortRoutes: true,
  strategy: "prefix",
  lazy: true,
  langDir: "i18n/",
  rootRedirect: null,
  detectBrowserLanguage: {"alwaysRedirect":true,"cookieAge":365,"cookieCrossOrigin":false,"cookieDomain":".hotmart.com","cookieKey":"hmLangCookie","cookieSecure":false,"fallbackLocale":"","redirectOn":"root","useCookie":true},
  differentDomains: false,
  baseUrl: "https://hotmart.com",
  vuex: {"moduleName":"i18n","syncRouteParams":true},
  parsePages: false,
  pages: {"index":{"pt-br":"/hotmartacademy","en":"/digital-learning","es":"/digital-learning","es-es":"/digital-learning","es-co":"/digital-learning","es-mx":"/digital-learning"},"thank-you":{"es-co":"/digital-learning/gracias","es-mx":"/digital-learning/gracias"}},
  skipSettingLocaleOnNavigate: false,
  onBeforeLanguageSwitch: () => {},
  onLanguageSwitched: () => null,
  fallbackLocale: "en",
  normalizedLocales: [{"name":"Español","code":"es","iso":"es","file":"es.js"},{"name":"Español - España","code":"es-es","iso":"es-ES","file":"es-es.js"},{"name":"Español - Colombia","code":"es-co","iso":"es-CO","file":"es-co.js"},{"name":"Español - Mexico","code":"es-mx","iso":"es-MX","file":"es-mx.js"},{"name":"English","code":"en","iso":"en","file":"en.js"},{"name":"Português","code":"pt-br","iso":"pt-br","file":"pt-br.js"}],
  localeCodes: ["es","es-es","es-co","es-mx","en","pt-br"],
  additionalMessages: [],
}
export const localeFiles = {
  0: "{",
  1: "\"",
  2: "e",
  3: "s",
  4: ".",
  5: "j",
  6: "s",
  7: "\"",
  8: ":",
  9: "\"",
  10: ".",
  11: ".",
  12: "/",
  13: "i",
  14: "1",
  15: "8",
  16: "n",
  17: "/",
  18: "e",
  19: "s",
  20: ".",
  21: "j",
  22: "s",
  23: "\"",
  24: ",",
  25: "\"",
  26: "e",
  27: "s",
  28: "-",
  29: "e",
  30: "s",
  31: ".",
  32: "j",
  33: "s",
  34: "\"",
  35: ":",
  36: "\"",
  37: ".",
  38: ".",
  39: "/",
  40: "i",
  41: "1",
  42: "8",
  43: "n",
  44: "/",
  45: "e",
  46: "s",
  47: "-",
  48: "e",
  49: "s",
  50: ".",
  51: "j",
  52: "s",
  53: "\"",
  54: ",",
  55: "\"",
  56: "e",
  57: "s",
  58: "-",
  59: "c",
  60: "o",
  61: ".",
  62: "j",
  63: "s",
  64: "\"",
  65: ":",
  66: "\"",
  67: ".",
  68: ".",
  69: "/",
  70: "i",
  71: "1",
  72: "8",
  73: "n",
  74: "/",
  75: "e",
  76: "s",
  77: "-",
  78: "c",
  79: "o",
  80: ".",
  81: "j",
  82: "s",
  83: "\"",
  84: ",",
  85: "\"",
  86: "e",
  87: "s",
  88: "-",
  89: "m",
  90: "x",
  91: ".",
  92: "j",
  93: "s",
  94: "\"",
  95: ":",
  96: "\"",
  97: ".",
  98: ".",
  99: "/",
  100: "i",
  101: "1",
  102: "8",
  103: "n",
  104: "/",
  105: "e",
  106: "s",
  107: "-",
  108: "m",
  109: "x",
  110: ".",
  111: "j",
  112: "s",
  113: "\"",
  114: ",",
  115: "\"",
  116: "e",
  117: "n",
  118: ".",
  119: "j",
  120: "s",
  121: "\"",
  122: ":",
  123: "\"",
  124: ".",
  125: ".",
  126: "/",
  127: "i",
  128: "1",
  129: "8",
  130: "n",
  131: "/",
  132: "e",
  133: "n",
  134: ".",
  135: "j",
  136: "s",
  137: "\"",
  138: ",",
  139: "\"",
  140: "p",
  141: "t",
  142: "-",
  143: "b",
  144: "r",
  145: ".",
  146: "j",
  147: "s",
  148: "\"",
  149: ":",
  150: "\"",
  151: ".",
  152: ".",
  153: "/",
  154: "i",
  155: "1",
  156: "8",
  157: "n",
  158: "/",
  159: "p",
  160: "t",
  161: "-",
  162: "b",
  163: "r",
  164: ".",
  165: "j",
  166: "s",
  167: "\"",
  168: "}",
}

export const localeMessages = {
  'es.js': () => import('../../i18n/es.js' /* webpackChunkName: "lang-es.js" */),
  'es-es.js': () => import('../../i18n/es-es.js' /* webpackChunkName: "lang-es-es.js" */),
  'es-co.js': () => import('../../i18n/es-co.js' /* webpackChunkName: "lang-es-co.js" */),
  'es-mx.js': () => import('../../i18n/es-mx.js' /* webpackChunkName: "lang-es-mx.js" */),
  'en.js': () => import('../../i18n/en.js' /* webpackChunkName: "lang-en.js" */),
  'pt-br.js': () => import('../../i18n/pt-br.js' /* webpackChunkName: "lang-pt-br.js" */),
}
